import React, { useEffect, useRef, useState, useContext } from "react";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function CorrectStudentPage1() {
  const { setClass10regulardata } = useContext(ContextBoard);
  const navigate = useNavigate();
  let candidateid;
  let category;
  // ---------------- REGISTRATION NUMBER FIELDS ----------------
  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [reg3, setReg3] = useState("");

  const [loading, setLoading] = useState(false);

  // Refs for auto-focus
  const reg1Ref = useRef();
  const reg2Ref = useRef();
  const reg3Ref = useRef();

  // ---------------- ROLL FIELDS ----------------
  const [rollCode, setRollCode] = useState("");
  const [rollNo, setRollNo] = useState("");

  // ---------------- HELPERS ----------------
  const allowDigits = (value) => value.replace(/\D/g, "");

  // Disable logic
  const isRegFilled = reg1 || reg2 || reg3;
  const isRollFilled = rollCode || rollNo;

  // -------- Registration field change handler --------
  const handleRegChange = (setter, value, max, nextRef) => {
    const v = allowDigits(value).slice(0, max);
    setter(v);

    if (v.length === max && nextRef?.current) {
      nextRef.current.focus();
    }
  };

  // -------- Backspace auto-focus previous --------
  const handleBackspace = (e, value, prevRef) => {
    if (e.key === "Backspace" && value.length === 0 && prevRef?.current) {
      prevRef.current.focus();
    }
  };
  useEffect(() => {
    setClass10regulardata("");
  }, [navigate]);
  const handleLoginWithCaptcha = async () => {
    // If user started entering Registration Number (any of reg1, reg2, reg3)
    const isRegEntered = reg1 || reg2 || reg3;

    // If user started entering Roll details
    const isRollEntered = rollCode || rollNo;

    // ------------------- VALIDATION -------------------
    if (isRegEntered) {
      // Validate Registration fields only
      if (!reg1 || !reg2 || !reg3) {
        Swal.fire(
          "Warning",
          "Please enter complete registration number",
          "warning"
        );
        return;
      }
    } else if (isRollEntered) {
      // Validate Roll fields only
      if (!rollCode) {
        Swal.fire("Warning", "Please enter roll code", "warning");
        return;
      }
      if (!rollNo) {
        Swal.fire("Warning", "Please enter roll number", "warning");
        return;
      }
    } else {
      // If NOTHING entered
      Swal.fire(
        "Warning",
        "Please enter either registration number or roll number",
        "warning"
      );
      return;
    }

    await handleLogin();
  };
  const handleLogin = async () => {
    setLoading(true);
    const referenceNo = reg1 && reg2 && reg3 ? `${reg1}-${reg2}-${reg3}` : null;
    const token = sessionStorage.getItem("tokenclassx");
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/SchoolForCorrectionPortal_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            refferencE_NO: referenceNo,
            rolL_NO: `${rollNo}` || null,
          }),
        }
      );

      const data = await response.json();
      // console.log("Login response:", data);
      if (response.ok) {
        console.log("Login response:", data);
        candidateid = data.data.candidatE_ID;
        category = data.data.studenT_EXAM_CATEGORY_DESCRIPTION;
        if (category === "EX-REGULAR") {
          // navigate(`/class-x-add-ex-regular-student`);
          const token = sessionStorage.getItem("tokenclassx");
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/EditDataEXRegularRegistration_CL10`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }
            navigate("/class-x-correction-exregular", {
              state: { studentData: result.data.editStudent_data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        } else if (category === "BETTERMENT") {
          const token = sessionStorage.getItem("tokenclassx");
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEditBtterment_CL10`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }
            navigate("/class-x-correction-improvement", {
              state: { studentData: result.data.editStudent_data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        } else {
          const token = sessionStorage.getItem("tokenclassx");
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEdit_CL10`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }

            setClass10regulardata(true);

            navigate("/class-x-correction-regular", {
              state: { candidateData: result.data.editStudent_data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        }
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-scroller">
        <Navbar10 />

        <div className="container-fluid page-body-wrapper">
          <Sidebar10 />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user"></i>&nbsp;Correct Student Data{" "}
                      <span className="text-danger">
                        ( Correction applicable for only challan generated
                        students )
                      </span>
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-x-dashboard");
                          }}
                        >
                          Home
                        </a>
                      </li>
                      <li className="active">Correct Student Data</li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* ---------------- SEARCH CARD ---------------- */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* ---------------- REGISTRATION NO ---------------- */}
                      <div className="col-md-3">
                        <label className="mb-2">
                          Please Enter Registration No:-
                        </label>
                        <div style={{ display: "flex", gap: "5px" }}>
                          {/* 5-digit PART 1 */}
                          <input
                            ref={reg1Ref}
                            type="text"
                            maxLength={5}
                            disabled={isRollFilled}
                            value={reg1}
                            onChange={(e) =>
                              handleRegChange(
                                setReg1,
                                e.target.value,
                                5,
                                reg2Ref
                              )
                            }
                            onKeyDown={(e) => handleBackspace(e, reg1, null)}
                            placeholder="5 digits"
                            className="form-control form-control-xs"
                          />

                          <div>-</div>

                          {/* 5-digit PART 2 */}
                          <input
                            ref={reg2Ref}
                            type="text"
                            maxLength={5}
                            disabled={isRollFilled}
                            value={reg2}
                            onChange={(e) =>
                              handleRegChange(
                                setReg2,
                                e.target.value,
                                5,
                                reg3Ref
                              )
                            }
                            onKeyDown={(e) => handleBackspace(e, reg2, reg1Ref)}
                            placeholder="5 digits"
                            className="form-control form-control-xs"
                          />

                          <div>-</div>

                          {/* 2-digit PART 3 */}
                          <input
                            ref={reg3Ref}
                            type="text"
                            maxLength={2}
                            disabled={isRollFilled}
                            value={reg3}
                            onChange={(e) =>
                              handleRegChange(setReg3, e.target.value, 2, null)
                            }
                            onKeyDown={(e) => handleBackspace(e, reg3, reg2Ref)}
                            placeholder="2 digits"
                            className="form-control form-control-xs"
                          />
                        </div>
                      </div>

                      <div
                        className="col-md-1 text-center text-danger"
                        style={{
                          height: "28px",
                          fontWeight: "600",
                          display: "none",
                        }}
                      >
                        Or
                      </div>

                      {/* ---------------- ROLL CODE ---------------- */}
                      <div className="col-md-2" style={{ display: "none" }}>
                        <label className="mb-2">Roll Code :</label>
                        <input
                          type="text"
                          maxLength={5}
                          disabled={isRegFilled}
                          value={rollCode}
                          onChange={(e) =>
                            setRollCode(allowDigits(e.target.value).slice(0, 5))
                          }
                          className="form-control form-control-xs"
                          placeholder="5 digits"
                        />
                      </div>

                      {/* ---------------- ROLL NUMBER ---------------- */}
                      <div className="col-md-2" style={{ display: "none" }}>
                        <label className="mb-2">Roll Number :</label>
                        <input
                          type="text"
                          maxLength={4}
                          disabled={isRegFilled}
                          value={rollNo}
                          onChange={(e) =>
                            setRollNo(allowDigits(e.target.value).slice(0, 4))
                          }
                          className="form-control form-control-xs"
                          placeholder="4 digits"
                        />
                      </div>

                      {/* ---------------- SEARCH BUTTON ---------------- */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-primary"
                          onClick={handleLoginWithCaptcha}
                        >
                          <i className="fa fa-search"></i>&nbsp;Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer10 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectStudentPage1;
